import type { ReactNode } from 'react'
import type { ControllerRenderProps, FieldPath, FieldValues } from 'react-hook-form'

import { FormControl, FormItem, FormLabel, FormMessage } from '@/components/ui/form'

import { BillingCurrencyInput } from './billing-currency-input.atom'

export interface BillingCurrencyFormFieldContentProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> {
  label: string
  field: ControllerRenderProps<TFieldValues, TName>
  min?: number
  max?: number
  placeholder?: string
  className?: string
}

export const BillingCurrencyFormFieldContent = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  label,
  field,
  min,
  max,
  placeholder,
  className,
}: BillingCurrencyFormFieldContentProps<TFieldValues, TName>): ReactNode => (
  <FormItem>
    <FormLabel>{label}</FormLabel>
    <FormControl>
      <BillingCurrencyInput
        min={min}
        max={max}
        placeholder={placeholder}
        className={className}
        value={field.value as number}
        onChange={field.onChange}
        onBlur={field.onBlur}
        name={field.name}
      />
    </FormControl>
    <FormMessage />
  </FormItem>
)
